import { get, post, put } from "../../../../services/request";

//-------------------RAD Type----------------//
// Get all RAD Types
export const getAllRadTypes = () => {
  return get("RadType/GetAllRadType");
};

// Get RAD Type by ID
export const getRadTypeById = (radTypeId) => {
  return get(`RadType/GetRadTypeByID?RadTypeID=${radTypeId}`);
};

// Save RAD Type (create new RAD Type)
export const saveRadType = (radTypeData) => {
  return post("RadType/SaveRadType", radTypeData);
};

// Create RAD Type
export const createRadType = (radTypeData) => {
  return post("RadType/CreateRadType", radTypeData);
};

// Update RAD Type
export const updateRadType = (radTypeData) => {
  return put(`RadType/UpdateRadType`, radTypeData);
};

// Delete RAD Type
export const deleteRadType = (radTypeId, modifiedBy) => {
  return post("RadType/DeleteRadType", {
    RadTypeID: radTypeId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate RAD Type
export const activateDeactivateRadType = (radTypeId, status, userId) => {
  return post("RadType/ActivateDeactivate", {
    Id: radTypeId,
    Status: status,
    UserId: userId,
  });
};

//-------------------RAD Status----------------//
// Get all RAD Status
export const getAllRadStatus = () => {
  return get("RadStatus/GetAllRadStatus");
};

// Get RAD Status by ID
export const getRadStatusById = (radStatusId) => {
  return get(`RadStatus/GetRadStatusByID?RadStatusID=${radStatusId}`);
};

// Save RAD Status (create new RAD Status)
export const saveRadStatus = (radStatusData) => {
  if (radStatusData.RadStatusID && radStatusData.RadStatusID !== "0") {
    return updateRadStatus(radStatusData);
  } else {
    return createRadStatus(radStatusData);
  }
};

// Create RAD Status
export const createRadStatus = (radStatusData) => {
  return post("RadStatus/SaveRadStatus", radStatusData);
};

// Update RAD Status
export const updateRadStatus = (radStatusData) => {
  return post(`RadStatus/SaveRadStatus`, radStatusData);
};

// Delete RAD Status
export const deleteRadStatus = (radStatusId, modifiedBy) => {
  return post("RadStatus/DeleteRadStatus", {
    RadStatusID: radStatusId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate RAD Status
export const activateDeactivateRadStatus = (radStatusId, status, userId) => {
  return post("RadStatus/ActivateDeactivate", {
    Id: radStatusId,
    Status: status,
    UserId: userId,
  });
};

//-------------------Subspeciality Services----------------//
// Get all subspecialities
export const getAllSubspecialities = () => {
  return get("Subspeciality/GetAllSubspeciality");
};

// Get subspeciality by ID
export const getSubspecialityById = (subspecialityId) => {
  return get(
    `Subspeciality/GetSubspecialityByID?SubspecialityID=${subspecialityId}`,
  );
};

// Save subspeciality
export const saveSubspeciality = (subspecialityData) => {
  return post("Subspeciality/SaveSubspeciality", subspecialityData);
};

// Delete subspeciality
export const deleteSubspeciality = (subspecialityId, modifiedBy) => {
  return post("Subspeciality/DeleteSubspeciality", {
    SubspecialityID: subspecialityId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate subspeciality
export const activateDeactivateSubspeciality = (
  subspecialityId,
  status,
  userId,
) => {
  return post("Subspeciality/ActivateDeactivate", {
    Id: subspecialityId,
    Status: status,
    UserId: userId,
  });
};

//-------------------Week Rotation Services----------------//
// Get all week rotations
export const getAllWeekRotations = () => {
  return get("WeekRotation/GetAllWeekRotation");
};

// Get week rotation by ID
export const getWeekRotationById = (weekRotationId) => {
  return get(
    `WeekRotation/GetWeekRotationByID?WeekRotationID=${weekRotationId}`,
  );
};

// Save week rotation
export const saveWeekRotation = (weekRotationData) => {
  return post("WeekRotation/SaveWeekRotation", weekRotationData);
};

// Delete week rotation
export const deleteWeekRotation = (weekRotationId, modifiedBy) => {
  return post("WeekRotation/DeleteWeekRotation", {
    WeekRotationID: weekRotationId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate week rotation
export const activateDeactivateWeekRotation = (
  weekRotationId,
  status,
  userId,
) => {
  return post("WeekRotation/ActivateDeactivate", {
    Id: weekRotationId,
    Status: status,
    UserId: userId,
  });
};

//-------------------Week Rotation Template Services----------------//
// Get all week rotation templates
export const getAllWeekRotationTemplates = () => {
  return get("WeekRotationTemplate/GetAllWeekRotationTemplate");
};

// Get week rotation template by ID
export const getWeekRotationTemplateById = (templateId) => {
  return get(
    `WeekRotationTemplate/GetWeekRotationTemplateByID?WeekRotationTemplateID=${templateId}`,
  );
};

// Save week rotation template
export const saveWeekRotationTemplate = (payload) => {
  return post("WeekRotationTemplate/SaveWeekRotationTemplate", payload);
};

// Delete week rotation template
export const deleteWeekRotationTemplate = (templateId, modifiedBy) => {
  return post("WeekRotationTemplate/DeleteWeekRotationTemplate", {
    WeekRotationTemplateID: templateId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate week rotation template
export const activateDeactivateWeekRotationTemplate = (
  templateId,
  status,
  userId,
) => {
  return post("WeekRotationTemplate/ActivateDeactivate", {
    Id: templateId,
    Status: status,
    UserId: userId,
  });
};

//-------------------RVU Rate Services----------------//
// Get all RVU rates
export const fetchRvuRateRequests = () => {
  return get("RadRUVRate/GetAllRadRUVRate");
};

// Get RVU rate by ID
export const getRvuRateById = (RadRUVRateID) => {
  return get(`RadRUVRate/GetRadRUVRateByID?RadRUVRateID=${RadRUVRateID}`);
};

// Save RVU rate
export const saveRvuRate = (rvuRateData) => {
  return post("RadRUVRate/SaveRadRUVRate", rvuRateData);
};

// Delete RVU rate
export const deleteRvuRate = (rvuRateId, modifiedBy) => {
  return post("RadRUVRate/DeleteRadRUVRate", {
    RadRUVRateID: rvuRateId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate RVU rate
export const activateDeactivateRvuRate = (rvuRateId, status, userId) => {
  return post("RadRUVRate/ActivateDeactivate", {
    Id: rvuRateId,
    Status: status,
    UserId: userId,
  });
};

//-------------------Schedule Type----------------//
// Get all schedule types
export const getAllScheduleTypes = () => {
  return get("ScheduleType/GetAllScheduleType");
};

// Get schedule type by ID
export const getScheduleTypeById = (scheduleTypeId) => {
  return get(
    `ScheduleType/GetScheduleTypeByID?ScheduleTypeID=${scheduleTypeId}`,
  );
};

// Save schedule type (create new schedule type)
export const saveScheduleType = (scheduleTypeData) => {
  return post("ScheduleType/SaveScheduleType", scheduleTypeData);
};

// Delete schedule type
export const deleteScheduleType = (scheduleTypeId, modifiedBy) => {
  return post("ScheduleType/DeleteScheduleType", {
    ScheduleTypeID: scheduleTypeId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate schedule type
export const activateDeactivateScheduleType = (
  scheduleTypeId,
  status,
  userId,
) => {
  return post("ScheduleType/ActivateDeactivate", {
    Id: scheduleTypeId,
    Status: status,
    UserId: userId,
  });
};

//-------------------Time Zone Services----------------//
// Get all time zones
export const fetchTimeZones = () => {
  return get("TimeZone/GetAllTimeZone");
};

// Get time zone by ID
export const getTimeZoneById = (TimeZoneID) => {
  return get(`TimeZone/GetTimeZoneByID?TimeZoneID=${TimeZoneID}`);
};

// Save time zone
export const saveTimeZone = (timeZoneData) => {
  return post("TimeZone/SaveTimeZone", timeZoneData);
};

// Delete time zone
export const deleteTimeZone = (TimeZoneID, modifiedBy) => {
  return post("TimeZone/DeleteTimeZone", {
    TimeZoneID: TimeZoneID,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate time zone
export const activateDeactivateTimeZone = (TimeZoneID, status, userId) => {
  return post("TimeZone/ActivateDeactivate", {
    Id: TimeZoneID,
    Status: status,
    UserId: userId,
  });
};

//-------------------RadCommunicationType Services----------------//
// Get all RadCommunicationTypes
export const getAllRadCommunicationTypes = () => {
  return get("RadCommunicationType/GetAllRadCommunicationType");
};

// Get RadCommunicationType by ID
export const getRadCommunicationTypeById = (Id) => {
  return get(
    `RadCommunicationType/GetRadCommunicationTypeByID?RadCommunicationTypeID=${Id}`,
  );
};

// Save RadCommunicationType
export const saveRadCommunicationType = (radCommunicationTypeData) => {
  return post(
    "RadCommunicationType/SaveRadCommunicationType",
    radCommunicationTypeData,
  );
};

// Delete RadCommunicationType
export const deleteRadCommunicationType = (
  radCommunicationTypeId,
  modifiedBy,
) => {
  return post("RadCommunicationType/DeleteRadCommunicationType", {
    RadCommunicationTypeID: radCommunicationTypeId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate RadCommunicationType
export const activateDeactivateRadCommunicationType = (id, status, userId) => {
  return post("RadCommunicationType/ActivateDeactivate", {
    ID: id,
    Status: status,
    UserID: userId,
  });
};

//-------------------Partnership Rate Services----------------//
// Get all partnership rates
export const getAllPartnershipRates = () => {
  return get("RadPartnershipRate/GetAllRadPartnershipRate");
};

// Get partnership rate by ID
export const getPartnershipRateById = (partnershipRateId) => {
  return get(
    `RadPartnershipRate/GetRadPartnershipRateByID?RadPartnershipRateID=${partnershipRateId}`,
  );
};

// Save partnership rate
export const savePartnershipRate = (partnershipRateData) => {
  return post("RadPartnershipRate/SaveRadPartnershipRate", partnershipRateData);
};

// Delete partnership rate
export const deletePartnershipRate = (partnershipRateId, modifiedBy) => {
  return post("RadPartnershipRate/DeleteRadPartnershipRate", {
    RadPartnershipRateID: partnershipRateId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate partnership rate
export const activateDeactivatePartnershipRate = (
  partnershipRateId,
  status,
  userId,
) => {
  return post("RadPartnershipRate/ActivateDeactivate", {
    Id: partnershipRateId,
    Status: status,
    UserId: userId,
  });
};

//-------------------Partnership Status Services----------------//
// Get all partnership statuses
export const getAllPartnershipStatuses = () => {
  return get("RadPartnershipStatus/GetAllRadPartnershipStatus");
};

// Get partnership status by ID
export const getPartnershipStatusById = (partnershipStatusId) => {
  return get(
    `RadPartnershipStatus/GetRadPartnershipStatusByID?RadPartnershipStatusID=${partnershipStatusId}`,
  );
};

// Save partnership status
export const savePartnershipStatus = (partnershipStatusData) => {
  return post(
    "RadPartnershipStatus/SaveRadPartnershipStatus",
    partnershipStatusData,
  );
};

// Delete partnership status
export const deletePartnershipStatus = (partnershipStatusId, modifiedBy) => {
  return post("RadPartnershipStatus/DeleteRadPartnershipStatus", {
    RadPartnershipStatusID: partnershipStatusId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate partnership status
export const activateDeactivatePartnershipStatus = (
  partnershipStatusId,
  status,
  userId,
) => {
  return post("RadPartnershipStatus/ActivateDeactivate", {
    Id: partnershipStatusId,
    Status: status,
    UserId: userId,
  });
};

//-------------------Partnership Time Services----------------//
// Get all partnership times
export const getAllPartnershipTimes = () => {
  return get("RadPartnershipTime/GetAllRadPartnershipTime");
};

// Get partnership time by ID
export const getPartnershipTimeById = (partnershipTimeId) => {
  return get(
    `RadPartnershipTime/GetRadPartnershipTimeByID?RadPartnershipTimeID=${partnershipTimeId}`,
  );
};

// Save partnership time
export const savePartnershipTime = (partnershipTimeData) => {
  return post("RadPartnershipTime/SaveRadPartnershipTime", partnershipTimeData);
};

// Delete partnership time
export const deletePartnershipTime = (partnershipTimeId, modifiedBy) => {
  return post("RadPartnershipTime/DeleteRadPartnershipTime", {
    RadPartnershipTimeID: partnershipTimeId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate partnership time
export const activateDeactivatePartnershipTime = (
  partnershipTimeId,
  status,
  userId,
) => {
  return post("RadPartnershipTime/ActivateDeactivate", {
    Id: partnershipTimeId,
    Status: status,
    UserId: userId,
  });
};

//-------------------Rad Degree Services----------------//
// Get all rad degrees
export const getAllRadDegree = () => {
  return get("RadDegree/GetAllRadDegree");
};

// Get rad degree by ID
export const getRadDegreeById = (RadDegreeID) => {
  return get(`RadDegree/GetRadDegreeByID?RadDegreeID=${RadDegreeID}`);
};

// Save rad degree
export const saveRadDegree = (radDegreeData) => {
  return post("RadDegree/SaveRadDegree", radDegreeData);
};

// Delete rad degree
export const deleteRadDegree = (RadDegreeID, modifiedBy) => {
  return post("RadDegree/DeleteRadDegree", {
    radDegreeid: RadDegreeID,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate rad degree
export const activateDeactivateRadDegree = (RadDegreeID, status, userId) => {
  return post("RadDegree/ActivateDeactivate", {
    Id: RadDegreeID,
    Status: status,
    UserId: userId,
  });
};

//-------------------Request Status Services----------------//
// Get all request status
export const getAllRequestStatus = () => {
  return get("RadScheduleRequestStatus/GetAllRadScheduleRequestStatus");
};

// Get request status by ID
export const getRequestStatusById = (RadScheduleRequestStatusID) => {
  return get(
    `RadScheduleRequestStatus/GetRadScheduleRequestStatusByID?RadScheduleRequestStatusID=${RadScheduleRequestStatusID}`,
  );
};

// Save request status
export const saveRequestStatus = (requeststatusData) => {
  return post(
    "RadScheduleRequestStatus/SaveRadScheduleRequestStatus",
    requeststatusData,
  );
};

// Delete request status
export const deleteRequestStatus = (RadScheduleRequestStatusID, modifiedBy) => {
  return post("RadScheduleRequestStatus/DeleteRadScheduleRequestStatus", {
    RadScheduleRequestStatusID: RadScheduleRequestStatusID,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate request status
export const activateDeactivateRequestStatus = (
  RadScheduleRequestStatusID,
  status,
  userId,
) => {
  return post("/RadScheduleRequestStatus/ActivateDeactivate", {
    Id: RadScheduleRequestStatusID,
    Status: status,
    UserId: userId,
  });
};

//-------------------Site Status Services----------------//
// Get all site status
export const getAllSiteStatus = () => {
  return get("SiteStatus/GetAllSiteStatus");
};

// Get site status by ID
export const getSiteStatusById = (SiteStatusID) => {
  return get(`SiteStatus/GetSiteStatusByID?SiteStatusID=${SiteStatusID}`);
};

// Save site status
export const saveSiteStatus = (siteStatusData) => {
  return post("SiteStatus/SaveSiteStatus", siteStatusData);
};

// Delete site status
export const deleteSiteStatus = (SiteStatusID, modifiedBy) => {
  return post("SiteStatus/DeleteSiteStatus", {
    SiteStatusID: SiteStatusID,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate site status
export const activateDeactivateSiteStatus = (SiteStatusID, status, userId) => {
  return post("SiteStatus/ActivateDeactivate", {
    Id: SiteStatusID,
    Status: status,
    UserId: userId,
  });
};

//-------------------Trauma Facility Level Services----------------//
// Get all trauma facility levels
export const getAllTraumaFacilityLevel = () => {
  return get("TramaFacilityLevel/GetAllTramaFacilityLevel");
};

// Get trauma facility level by ID
export const getTraumaFacilityLevelById = (TramaFacilityLevelID) => {
  return get(
    `TramaFacilityLevel/GetTramaFacilityLevelByID?TramaFacilityLevelID=${TramaFacilityLevelID}`,
  );
};

// Save trauma facility level
export const saveTraumaFacilityLevel = (traumaFacilityLevelData) => {
  return post(
    "TramaFacilityLevel/SaveTramaFacilityLevel",
    traumaFacilityLevelData,
  );
};

// Delete trauma facility level
export const deleteTraumaFacilityLevel = (TramaFacilityLevelID, modifiedBy) => {
  return post("TramaFacilityLevel/DeleteTramaFacilityLevel", {
    TramaFacilityLevelID: TramaFacilityLevelID,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate trauma facility level
export const activateDeactivateTraumaFacilityLevel = (
  TramaFacilityLevelID,
  status,
  userId,
) => {
  return post("TramaFacilityLevel/ActivateDeactivate", {
    Id: TramaFacilityLevelID,
    Status: status,
    UserId: userId,
  });
};

//-------------------Committees Services----------------//
// Get all committees
export const getAllCommittees = () => {
  return get("RadCommittees/GetAllRadCommittees");
};

// Get committee by ID
export const getCommitteesById = (RadCommitteeID) => {
  return get(
    `RadCommittees/GetRadCommitteesByID?RadCommitteesID=${RadCommitteeID}`,
  );
};

// Save committees
export const saveCommittees = (committeesData) => {
  return post("RadCommittees/SaveRadCommittees", committeesData);
};

// Delete committees
export const deleteCommittees = (RadCommitteeID, modifiedBy) => {
  return post("RadCommittees/DeleteRadCommittees", {
    radCommitteeID: RadCommitteeID,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate committees
export const activateDeactivateCommittees = (
  RadCommitteeID,
  status,
  userId,
) => {
  return post("RadCommittees/ActivateDeactivate", {
    Id: RadCommitteeID,
    Status: status,
    UserId: userId,
  });
};

//-------------------QGenda Section Services----------------//
// Get all QGenda sections
export const getAllQgendaSections = () => {
  return get("RadQGendaSection/GetAllRadQGendaSection");
};

// Get QGenda section by ID
export const getQgendaSectionById = (Id) => {
  return get(`RadQGendaSection/GetRadQGendaSectionByID?QGendaSectionID=${Id}`);
};

// Save QGenda section
export const saveQgendaSection = (qGendaSectionData) => {
  return post("RadQGendaSection/SaveRadQGendaSection", qGendaSectionData);
};

// Delete QGenda section
export const deleteQgendaSection = (qGendaSectionId, modifiedBy) => {
  return post("RadQGendaSection/DeleteRadQGendaSection", {
    QGendaSectionID: qGendaSectionId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate QGenda section
export const activateDeactivateQgendaSection = (id, status, userId) => {
  return post("RadQGendaSection/ActivateDeactivate", {
    Id: id,
    Status: status,
    UserId: userId,
  });
};

//-------------------Future Section Change Services----------------//
// Get all future section changes
export const getAllFutureSectionChange = () => {
  return get("RadScheduleFutureSection/GetAllRadScheduleFutureSection");
};

// Get future section change by ID
export const getFutureSectionChangeById = (RadScheduleFutureSectionID) => {
  return get(
    `RadScheduleFutureSection/GetRadScheduleFutureSectionByID?RadScheduleFutureSectionID=${RadScheduleFutureSectionID}`,
  );
};

// Save future section change
export const saveFutureSectionChange = (RadFutureSectionChangeData) => {
  return post(
    "RadScheduleFutureSection/SaveRadScheduleFutureSection",
    RadFutureSectionChangeData,
  );
};

// Delete future section change
export const deleteFutureSectionChange = (
  RadScheduleFutureSectionID,
  modifiedBy,
) => {
  return post("RadScheduleFutureSection/DeleteRadScheduleFutureSection", {
    radScheduleFutureSectionID: RadScheduleFutureSectionID,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate future section change
export const activateDeactivateFutureSectionChange = (
  RadScheduleFutureSectionID,
  status,
  userId,
) => {
  return post("RadScheduleFutureSection/ActivateDeactivate", {
    Id: RadScheduleFutureSectionID,
    Status: status,
    UserId: userId,
  });
};

//Staff Category Services
// Get all staff categories
export const getAllStaffCategories = () => {
  return get("StaffCategory/GetAllStaffCategory");
};

// Get staff category by ID
export const getStaffCategoryById = (StaffCategoryId) => {
  return get(
    `StaffCategory/GetStaffCategoryByID?StaffCategoryId=${StaffCategoryId}`,
  );
};

// Save staff category
export const saveStaffCategory = (staffCategoryData) => {
  return post("StaffCategory/SaveStaffCategory", staffCategoryData);
};

// Delete staff category
export const deleteStaffCategory = (StaffCategoryId, modifiedBy) => {
  return post("StaffCategory/DeleteStaffCategory", {
    StaffCategoryId: StaffCategoryId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate staff category
export const activateDeactivateStaffCategory = (
  StaffCategoryId,
  status,
  userId,
) => {
  return post("StaffCategory/ActivateDeactivate", {
    Id: StaffCategoryId,
    Status: status,
    UserId: userId,
  });
};

//-------------------Modality Services----------------//
// Get all modalities
export const getAllModality = () => {
  return get("ModalitiesManagement/GetAllModalities");
};

// Get modality by ID
export const getModalityById = (ModalityId) => {
  return get(`ModalitiesManagement/GetModalityByID?ModalityId=${ModalityId}`);
};

// Save modality
export const saveModality = (modalityData) => {
  return post("ModalitiesManagement/SaveModality", modalityData);
};

// Delete modality
export const deleteModality = (ModalityId, modifiedBy) => {
  return post("ModalitiesManagement/DeleteModalityByID", {
    ModalityId: ModalityId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate modality
export const activateDeactivateModality = (ModalityId, status, userId) => {
  return post("ModalitiesManagement/EnableDisableModalityByID", {
    ModalityId: ModalityId,
    Status: status,
    UserId: userId,
  });
};

//Staff Primary Location Services
// Get all staff primary locations
export const getAllStaffPrimaryLocations = () => {
  return get("StaffPrimaryWorkLocation/GetAll");
};

// Get staff primary location by ID
export const getStaffPrimaryLocationById = (StaffPrimaryLocationID) => {
  return get(
    `StaffPrimaryWorkLocation/GetById?staffPrimaryLocationId=${StaffPrimaryLocationID}`,
  );
};

// Save staff primary location
export const saveStaffPrimaryLocation = (staffPrimaryLocationData) => {
  return post("StaffPrimaryWorkLocation/Save", staffPrimaryLocationData);
};

// Delete staff primary location
export const deleteStaffPrimaryLocation = (StaffPrimaryLocationID) => {
  return post("StaffPrimaryWorkLocation/DeleteById", {
    StaffPrimaryLocationId: StaffPrimaryLocationID,
  });
};

// Activate/Deactivate staff primary location
export const activateDeactivateStaffPrimaryLocation = (
  StaffPrimaryLocationID,
  status,
) => {
  return post("StaffPrimaryWorkLocation/ActivateDeactivate", {
    Id: StaffPrimaryLocationID,
    Status: status,
  });
};

//-------------------Priority Services----------------//
// Get all priorities
export const getAllPriority = () => {
  return get("PrioritiesManagement/GetAllPriorities");
};

// Get priority by ID
export const getPriorityById = (PriorityId) => {
  return get(`PrioritiesManagement/GetPriorityByID?PriorityId=${PriorityId}`);
};

// Save priority
export const savePriority = (priorityData) => {
  return post("PrioritiesManagement/SavePriority", priorityData);
};

// Delete priority
export const deletePriority = (PriorityId, modifiedBy) => {
  return post("PrioritiesManagement/DeletePriorityByID", {
    PriorityId: PriorityId,
    ModifiedBy: modifiedBy,
  });
};

// Activate/Deactivate priority
export const activateDeactivatePriority = (PriorityId, status, userId) => {
  return post("PrioritiesManagement/EnableDisablePriorityByID", {
    PriorityId: PriorityId,
    Status: status,
    UserId: userId,
  });
};

// Get all priority buckets
export const getAllPriorityBuckets = () => {
  return get("PrioritiesManagement/GetAllPriorityBuckets");
};

//-------------------Specialty Cases Services----------------//
export const getAllSpecialtyCases = () => {
  return get("RadSpecialityCase/GetAllRadSpecialityCase");
};

export const getSpecialtyCaseById = (SpecialtyCaseID) => {
  return get(
    `RadSpecialityCase/GetRadSpecialityCaseByID?RadSpecialityCaseId=${SpecialtyCaseID}`,
  );
};

export const saveSpecialtyCase = (specialtyCaseData) => {
  const parsedId = Number(
    specialtyCaseData?.RadSpecialityCaseId ??
      specialtyCaseData?.SpecialtyCaseID,
  );

  const payload = {
    RadSpecialityCaseId: Number.isFinite(parsedId) ? parsedId : 0,
    RadSpecialityCaseName:
      specialtyCaseData?.RadSpecialityCaseName?.trim() || "",
  };

  return post("RadSpecialityCase/SaveRadSpecialityCase", payload);
};

export const deleteSpecialtyCase = (SpecialtyCaseID, modifiedBy) => {
  return post("RadSpecialityCase/DeleteRadSpecialityCase", {
    RadSpecialityCaseId: SpecialtyCaseID,
    ModifiedBy: modifiedBy,
  });
};

export const activateDeactivateSpecialtyCase = (
  SpecialtyCaseID,
  status,
  userId,
) => {
  return post("RadSpecialityCase/ActivateDeactivate", {
    Id: SpecialtyCaseID,
    Status: status,
    UserId: userId,
  });
};

//-------------------Staffing Agency Services----------------//
export const getAllStaffingAgency = () => {
  return get("StaffingAgency/GetAllStaffingAgency");
};

export const getStaffingAgencyById = (staffingAgencyId) => {
  return get(
    `StaffingAgency/GetStaffingAgencyByID?staffingAgencyID=${staffingAgencyId}`,
  );
};

export const saveStaffingAgency = (staffingAgencyData) => {
  return post("StaffingAgency/SaveStaffingAgency", staffingAgencyData);
};

export const deleteStaffingAgency = (staffingAgencyId, modifiedBy) => {
  return post("StaffingAgency/DeleteStaffingAgency", {
    StaffingAgencyID: staffingAgencyId,
    // ModifiedBy: modifiedBy,
  });
};

export const activateDeactivateStaffingAgency = (
  staffingAgencyId,
  status,
  userId,
) => {
  return post("StaffingAgency/ActivateDeactivate", {
    Id: staffingAgencyId,
    Status: status,
    // UserId: userId,
  });
};

//-------------------Provider Document Services----------------//
// Get all PROVIDER DOCUMENT Types
export const getAllProviderDocumentTypes = () => {
  return get("RadDocumentType/GetAllRadDocumentType");
};

// Get PROVIDER DOCUMENT Type by ID
export const getProviderDocumentTypeById = (id) => {
  return get(`RadDocumentType/GetRadDocumentTypeByID?DocumentTypeID=${id}`);
};

// Save PROVIDER DOCUMENT Type (create new PROVIDER DOCUMENT Type)
export const saveProviderDocumentType = (docTypeData) => {
  return post("RadDocumentType/SaveRadDocumentType", docTypeData);
};

// Create PROVIDER DOCUMENT Type
export const createProviderDocumentType = (docTypeData) => {
  return post("RadDocumentType/SaveRadDocumentType", docTypeData);
};

// Update PROVIDER DOCUMENT Type
export const updateProviderDocumentType = (docTypeData) => {
  return put(`RadDocumentType/SaveRadDocumentType`, docTypeData);
};

// Delete PROVIDER DOCUMENT Type
export const deleteProviderDocumentType = (payload) => {
  return post("RadDocumentType/DeleteRadDocumentType", payload);
};

// Activate/Deactivate PROVIDER DOCUMENT Type
export const activateDeactivateProviderDocumentType = (payload) => {
  return post("RadDocumentType/ActivateDeactivate", payload);
};

//-------------------Provider Note Type Services----------------//
// Get all Provider Note Types
export const getAllProviderNoteTypes = () => {
  return get("RadNoteType/GetAllRadNoteType");
};

// Get Provider Note Type by ID
export const getProviderNoteTypeById = (id) => {
  return get(`RadNoteType/GetRadNoteTypeByID?RadNoteTypeID=${id}`);
};

// Save Provider Note Type
export const saveProviderNoteType = (noteTypeData) => {
  return post("RadNoteType/SaveRadNoteType", noteTypeData);
};

// Delete Provider Note Type
export const deleteProviderNoteType = (payload) => {
  return post("RadNoteType/DeleteRadNoteType", payload);
};

// Activate/Deactivate Provider Note Type
export const activateDeactivateProviderNoteType = (payload) => {
  return post("RadNoteType/ActivateDeactivateRadNoteType", payload);
};
